import React, { useState } from 'react';
import axios from 'axios';
import './CahierDesCharges.css';

function CahierDesChargesDestratificateurs() {
  const [isUnlocked, setIsUnlocked] = useState(false);
  const [accessCode, setAccessCode] = useState('');
  const [codeError, setCodeError] = useState(false);

  const ACCESS_CODE = '2626';

  const handleCodeSubmit = (e) => {
    e.preventDefault();
    if (accessCode.trim().toUpperCase() === ACCESS_CODE) {
      setIsUnlocked(true);
      setCodeError(false);
    } else {
      setCodeError(true);
    }
  };

  const [formData, setFormData] = useState({
    nom: '',
    email: '',
    telephone: '',
    message: ''
  });
  const [formSent, setFormSent] = useState(false);

  const currentDate = new Date().toLocaleDateString('fr-FR', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  // SVG Icons
  const icons = {
    target: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/>
      </svg>
    ),
    user: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>
      </svg>
    ),
    phone: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
      </svg>
    ),
    check: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/>
      </svg>
    ),
    tool: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>
      </svg>
    ),
    settings: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"/>
      </svg>
    ),
    clipboard: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><rect x="8" y="2" width="8" height="4" rx="1" ry="1"/>
      </svg>
    ),
    info: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/>
      </svg>
    ),
    rocket: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"/><path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"/><path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"/><path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"/>
      </svg>
    ),
    award: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="8" r="7"/><polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"/>
      </svg>
    ),
    whatsapp: (
      <svg viewBox="0 0 24 24" fill="currentColor">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
      </svg>
    ),
    send: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/>
      </svg>
    )
  };

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    setError('');

    try {
      const message = `[Cahier des charges — Déstratificateurs CEE] ${formData.message || ''}`.trim();
      await axios.post('/api/candidatures', { ...formData, message });
      setFormSent(true);
      setFormData({ nom: '', email: '', telephone: '', message: '' });
    } catch (err) {
      console.error('Erreur envoi candidature:', err);
      setError('Une erreur est survenue. Veuillez réessayer.');
    } finally {
      setSending(false);
    }
  };

  if (!isUnlocked) {
    return (
      <div className="cahier-des-charges-public">
        <div className="cahier-lock-screen">
          <div className="lock-card">
            <div className="lock-icon-container">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lock-svg">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
              </svg>
            </div>
            <img src="/logo-eshops-pro.png" alt="E-Shops PRO" style={{ height: '54px', width: 'auto', objectFit: 'contain', marginBottom: '8px' }} />
            <h2 className="lock-title">Document Confidentiel</h2>
            <p className="lock-subtitle">Veuillez entrer le code d'acces pour consulter le Cahier des Charges</p>
            <form onSubmit={handleCodeSubmit} className="lock-form">
              <input
                type="text"
                value={accessCode}
                onChange={(e) => { setAccessCode(e.target.value); setCodeError(false); }}
                placeholder="Code d'acces"
                className={`lock-input ${codeError ? 'lock-input-error' : ''}`}
                autoFocus
                autoComplete="off"
              />
              {codeError && <p className="lock-error-msg">Code incorrect. Veuillez reessayer.</p>}
              <button type="submit" className="lock-btn">Acceder au document</button>
            </form>
            <p className="lock-hint">Contactez votre responsable si vous n'avez pas le code.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="cahier-des-charges-public">
      <div className="cahier-des-charges">
        <div className="cahier-header">
          <div className="header-badge">Document Officiel</div>
          <div className="cahier-title-section">
            <div className="logo-container">
              <img
                src="/logo-eshops-pro.png"
                alt="E-Shops PRO"
                style={{ height: '64px', width: 'auto', objectFit: 'contain' }}
              />
            </div>
            <h1>Cahier des Charges</h1>
            <p className="cahier-subtitle">Déstratificateurs d'air — Certificats d'Économies d'Énergie (CEE)</p>
          </div>
          <p className="cahier-date">Mis à jour le {currentDate}</p>
        </div>

        {/* Hero section */}
        <div className="hero-illustration">
          <div className="hero-content">
            <div className="hero-icon-svg">{icons.rocket}</div>
            <h2>Devis signés conformes</h2>
            <p>Opérations CEE — Déstratificateurs d'air industriels & tertiaires</p>
          </div>
          <div className="hero-devices">
            <div className="mini-laptop">
              <div className="mini-screen"></div>
              <div className="mini-base"></div>
            </div>
            <div className="mini-phone">
              <div className="mini-phone-screen"></div>
            </div>
          </div>
        </div>

        <div className="cahier-content">
          {/* Objectif */}
          <section className="cahier-section">
            <div className="section-header">
              <span className="section-icon-svg">{icons.target}</span>
              <h2>Objectif</h2>
            </div>
            <div className="section-content">
              <p>
                Obtenir des <strong>devis signés conformes</strong> pour l'installation de <strong>déstratificateurs d'air</strong>,
                dans le cadre des <strong>Certificats d'Économies d'Énergie (CEE)</strong>. Le déstratificateur récupère l'air chaud
                accumulé en hauteur pour le redistribuer au niveau de l'activité, générant des économies d'énergie immédiates
                et éligibles à une <strong>prime CEE</strong>.
              </p>
            </div>
          </section>

          {/* Opérations CEE concernées */}
          <section className="cahier-section">
            <div className="section-header">
              <span className="section-icon-svg">{icons.clipboard}</span>
              <h2>Opérations CEE concernées</h2>
            </div>
            <div className="section-content">
              <ul className="criteria-list">
                <li>
                  <span className="check-icon-svg">{icons.check}</span>
                  <span className="criteria-text"><strong>IND-BA-110</strong> — Système de déstratification d'air pour le <strong>secteur industriel</strong>.</span>
                </li>
                <li>
                  <span className="check-icon-svg">{icons.check}</span>
                  <span className="criteria-text"><strong>BAT-TH-142</strong> — Système de déstratification ou de destratification/brassage d'air pour le <strong>secteur tertiaire</strong>.</span>
                </li>
              </ul>
            </div>
          </section>

          {/* Critères d'éligibilité */}
          <section className="cahier-section highlight-section">
            <div className="section-header">
              <span className="section-icon-svg">{icons.check}</span>
              <h2>Critères d'éligibilité</h2>
            </div>
            <div className="section-content">
              <p className="section-intro">Pour qu'un site soit éligible, <strong>tous</strong> les critères suivants doivent être réunis :</p>
              <div className="validation-grid">
                <div className="validation-item valid">
                  <span className="validation-icon-svg">{icons.check}</span>
                  <span>Hauteur minimale de <strong>5 mètres sous plafond</strong></span>
                </div>
                <div className="validation-item valid">
                  <span className="validation-icon-svg">{icons.check}</span>
                  <span>Puissance de chauffage <strong>cumulée de 275 kW</strong></span>
                </div>
                <div className="validation-item valid">
                  <span className="validation-icon-svg">{icons.check}</span>
                  <span>Bâtiment <strong>industriel (IND-BA-110)</strong> ou <strong>tertiaire (BAT-TH-142)</strong></span>
                </div>
                <div className="validation-item valid">
                  <span className="validation-icon-svg">{icons.check}</span>
                  <span>Présence d'un <strong>système de chauffage existant</strong> générant de l'air chaud en hauteur</span>
                </div>
              </div>
            </div>
          </section>

          {/* Devis conforme */}
          <section className="cahier-section">
            <div className="section-header">
              <span className="section-icon-svg">{icons.info}</span>
              <h2>Qu'est-ce qu'un devis signé conforme ?</h2>
            </div>
            <div className="section-content">
              <p className="section-intro">Un devis est considéré comme <strong>conforme</strong> s'il réunit l'ensemble des éléments suivants :</p>

              <div className="qualification-block">
                <h3><span className="block-icon">{icons.clipboard}</span> Identité du bénéficiaire</h3>
                <ul className="checklist">
                  <li><span className="bullet"></span><span className="checklist-text">Raison sociale et SIRET de l'entreprise</span></li>
                  <li><span className="bullet"></span><span className="checklist-text">Nom du décisionnaire signataire (gérant / responsable)</span></li>
                  <li><span className="bullet"></span><span className="checklist-text">Adresse complète du site d'installation</span></li>
                  <li><span className="bullet"></span><span className="checklist-text">Téléphone et email de contact</span></li>
                </ul>
              </div>

              <div className="qualification-block">
                <h3><span className="block-icon">{icons.settings}</span> Caractéristiques techniques du site</h3>
                <ul className="checklist">
                  <li><span className="bullet"></span><span className="checklist-text">Hauteur sous plafond confirmée (≥ 5 m)</span></li>
                  <li><span className="bullet"></span><span className="checklist-text">Puissance de chauffage cumulée confirmée (275 kW)</span></li>
                  <li><span className="bullet"></span><span className="checklist-text">Type d'opération identifié : IND-BA-110 ou BAT-TH-142</span></li>
                </ul>
              </div>

              <div className="qualification-block">
                <h3><span className="block-icon">{icons.check}</span> Signature et engagement</h3>
                <ul className="checklist">
                  <li><span className="bullet"></span><span className="checklist-text">Devis daté et <strong>signé</strong> par le décisionnaire</span></li>
                  <li><span className="bullet"></span><span className="checklist-text">Mention « Bon pour accord » et cachet de l'entreprise</span></li>
                  <li><span className="bullet"></span><span className="checklist-text">Bénéficiaire informé du dispositif CEE et de la prime associée</span></li>
                </ul>
              </div>
            </div>
          </section>

          {/* Rémunération */}
          <section className="cahier-section remuneration-section">
            <div className="section-header">
              <span className="section-icon-svg">{icons.award}</span>
              <h2>Votre Rémunération</h2>
            </div>
            <div className="section-content remuneration-content">
              <div className="remuneration-highlight">
                <div className="remuneration-badge">Commission par devis signé conforme</div>
                <div className="remuneration-amount">
                  <span className="amount-range">350 € — 1 000 €</span>
                  <span className="amount-label">par devis signé</span>
                </div>
                <p className="remuneration-detail">
                  Plus vous signez de devis conformes, <strong>plus votre commission par devis augmente</strong>. Le palier se calcule
                  sur le nombre total de devis signés.
                </p>

                <div className="reporting-table" style={{ marginTop: '20px' }}>
                  <div className="reporting-row">
                    <span className="reporting-label">5 premiers devis signés</span>
                    <span className="reporting-value"><strong>350 €</strong> / devis</span>
                  </div>
                  <div className="reporting-row">
                    <span className="reporting-label">De 10 à 15 devis signés</span>
                    <span className="reporting-value"><strong>500 €</strong> / devis</span>
                  </div>
                  <div className="reporting-row">
                    <span className="reporting-label">De 20 à 30 devis signés</span>
                    <span className="reporting-value"><strong>750 €</strong> / devis</span>
                  </div>
                  <div className="reporting-row">
                    <span className="reporting-label">Plus de 30 devis signés</span>
                    <span className="reporting-value"><strong>1 000 €</strong> / devis</span>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>

        {/* Contact & Inscription */}
        <section className="cahier-section contact-section">
          <div className="section-header">
            <span className="section-icon-svg">{icons.send}</span>
            <h2>Rejoignez-nous</h2>
          </div>
          <div className="section-content">
            <div className="contact-grid">
              <div className="contact-form-wrapper">
                <h3>Inscription</h3>
                {formSent ? (
                  <div className="form-success">
                    <span className="success-check">{icons.check}</span>
                    <p>Merci ! Nous vous recontacterons rapidement.</p>
                  </div>
                ) : (
                  <form onSubmit={handleSubmit} className="contact-form">
                    {error && <div className="form-error">{error}</div>}
                    <input
                      type="text"
                      name="nom"
                      placeholder="Votre nom"
                      value={formData.nom}
                      onChange={handleInputChange}
                      required
                      disabled={sending}
                    />
                    <input
                      type="email"
                      name="email"
                      placeholder="Votre email"
                      value={formData.email}
                      onChange={handleInputChange}
                      required
                      disabled={sending}
                    />
                    <input
                      type="tel"
                      name="telephone"
                      placeholder="Votre téléphone"
                      value={formData.telephone}
                      onChange={handleInputChange}
                      required
                      disabled={sending}
                    />
                    <textarea
                      name="message"
                      placeholder="Votre message (optionnel)"
                      value={formData.message}
                      onChange={handleInputChange}
                      rows="3"
                      disabled={sending}
                    />
                    <button type="submit" className="btn-submit" disabled={sending}>
                      {sending ? 'Envoi en cours...' : 'Envoyer ma candidature'}
                    </button>
                  </form>
                )}
              </div>

              <div className="contact-info-wrapper">
                <h3>Contact direct</h3>
                <p className="contact-text">Une question ? Contactez-nous directement :</p>
                <div className="contact-buttons">
                  <a
                    href="https://wa.me/33743678501"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="whatsapp-btn"
                  >
                    <span className="whatsapp-icon">{icons.whatsapp}</span>
                    <span>WhatsApp</span>
                  </a>
                  <a
                    href="tel:+33743678501"
                    className="phone-btn"
                  >
                    <span className="phone-icon">{icons.phone}</span>
                    <span>Appeler</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="cahier-footer">
          <div className="footer-logo">E-Shop Pro</div>
          <p>Document officiel — {currentDate}</p>
          <p className="footer-tagline">Votre partenaire CEE de confiance</p>
        </div>
      </div>
    </div>
  );
}

export default CahierDesChargesDestratificateurs;
